import _ from 'underscore'
import ProfileViewTemplate from '../templates/profile.tpl'
import HeaderView from './header'
import NavView from './nav'
import EditUserView from './edit-user'

const ProfileView = EditUserView.extend({
    el: '#current-view',
    update: true,
    initialize() {
        this.template = _.template(ProfileViewTemplate)
    },
    render() {
        const data = this.model.toJSON()
        data.purchased = this.model.get('purchased').decorate()
        this.$el.html(this.template(data))

        const headerView = new HeaderView()
        this.$('#header-view').append(headerView.render().el)

        const navView = new NavView()
        this.$('#nav-view').append(navView.render().el)

        return this
    },
    close() {
        this.render()
    },
})

export default ProfileView
